<template>
    <div class="mdc-dialog"
            id="nextLessonDialog"
        >
        <div class="mdc-dialog__container">
            <div class="mdc-dialog__surface">
                <h2 class="mdc-dialog__title" id="my-dialog-title">
                    {{$t('958')}}
                    <!-- 레슨이 모두 끝났습니다! -->
                </h2>
                <div class="mdc-dialog__content" id="my-dialog-content">
                    <div class="t-color-bodyGrayA"> 
                        {{$t('959')}}
                        <!-- 다음 레슨 -->
                    </div>
                    <div class="t-subtitle3" :class="nextLesson.contentsType && nextLesson.contentsType.value=='VIDEO' ? 'mgb-10':''">
                        {{nextLesson.name}}
                    </div>
                    <div class="circular-body t-headline3" :class="nextLesson.contentsType && nextLesson.contentsType.value=='VIDEO' ? 'checkbackground':''" :style="nextLesson.contentsType && nextLesson.contentsType.value=='VIDEO'? `background-image: url(${thumbnails});`: ''">
                        
                        <circular-count-down-timer
                                :stroke-width="5"
                                :underneath-stroke-color="'#FEDDDD'"
                                :seconds-fill-color="'#FEDDDD'"
                                :seconds-stroke-color="'#fc5356'"
                                :initial-value="5"
                                :steps="1"
                                second-label=""
                                :show-negatives="false"
                                @finish="moveNextLesson(nextLesson)"
                        ></circular-count-down-timer>
                    </div>
                </div>
                <footer class="mdc-dialog__actions">
                    <button type="button" class="mdc-button mdc-dialog__button btn-white t-color-secondaryBtnText" data-mdc-dialog-action="no" tabindex="0" @click="moveLearnView()" @keypress="moveLearnView()">
                        {{$t('960')}}
                        <!-- 나중에 하기 -->
                    </button>
                    <!-- <button type="button" class="mdc-button mdc-dialog__button btn-white" data-mdc-dialog-action="no" @click="moveNextLesson(nextLesson)">
                        {{$t('Todo-바로 학습하기')}}                    
                    </button> -->
                </footer>
            </div>
        </div>
        <div class="mdc-dialog__scrim"></div>
    </div>
</template>

<script>
/**
 * 나의 학습 차시 학습창 - 다음학습 팝업 컴포넌트(my learning lesson study - next lesson popup component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCDialog} from '@material/dialog'
import learnApi from '@/api/learnApi.js'
import {MDCRipple} from '@material/ripple'

export default {
    props: ['nextLesson','thumbnailVideo','type'],
    data() {
        return {
            nextLessonDialog: null,
            thumbnails:null
        }
    },
    mounted() {
        this.setMaterialUi()
        this.nextLessonDialog = new MDCDialog(document.getElementById('nextLessonDialog'))
        this.nextLessonDialog.open()

        let learnId = this.$route.params.learnId
        if(this.nextLesson) {
            let contentsType = this.nextLesson && this.nextLesson.contentsType ? this.nextLesson.contentsType.value:'';
            if(contentsType=='VIDEO') {
                let progressionId = this.nextLesson? this.nextLesson.progressionId:'';
                let params = {learnId:learnId,progressionId:progressionId}
                learnApi.learnLessonContents(params).then((response) => {
                    this.thumbnails = response.data.data && response.data.data.video?response.data.data.video.thumbnails[0]:null;
                    //let getThumbnail = response.data.data
                    //this.thumbnailVideo = getThumbnail.thumbnail
                }).catch((err) => {})
            }
              
        }
    },

    methods: {
        moveLearnView() {
            //this.$emit('moveLearnView')
            let goBackBookMarkLessson = localStorage.getItem('videoBookMarkLesson')
            let goBackLikeLessson = localStorage.getItem('videoLikeLesson')
            if(goBackBookMarkLessson == 'setVideoBookMarkLesson'){
                localStorage.removeItem('videoBookMarkLesson');
                this.$router.push({
                    name: 'BookMarkedLesson' 
                })
            }else if(goBackLikeLessson=='setVideoLikeLesson'){
                localStorage.removeItem('videoLikeLesson');
                this.$router.push({
                    name: 'LikedLesson' 
                })
            }else{
                
                this.$router.push({
                name: 'LearnView', 
                params: {learnId: this.$route.params.learnId},
                query: this.$route.query
                })
            }
        },

        // 다음 학습으로 이동(move next lesson learning)
        moveNextLesson(lesson) {
            this.nextLessonDialog.close()
            let learnId = this.$route.params.learnId
            let status = this.$route.query.status
            //console.log('lesson=>',lesson)
            //console.log('moveNextLesson=>',this.$router.push(`/learn/${learnId}/lessonContents/${lesson.progressionId}`))

            if(lesson && lesson.contentsType && lesson.contentsType.value=='VIDEO') {
                this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=`+status)
            } else if(lesson && lesson.contentsType && lesson.contentsType.value=='EXAM_PAPER'){
                this.$router.push(`/learn-study/${learnId}/lessonExam/${lesson.examineeId}/intro?status=`+status)
            }else if(lesson && lesson.contentsType && lesson.contentsType.value=='PDF'){
                this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=`+status)
            } else if(lesson && lesson.contentsType && lesson.contentsType.value === 'LIVE_SESSION'){
                        let params = {
                            learnId: this.$route.params.learnId,
                            progressionId: lesson.progressionId
                        }
                        learnApi.learnLessonContents(params).then((response) => {
                        let liveSessionTrueFalse = response.data.data.liveSession.canParticipate
                            if(liveSessionTrueFalse == false) {
                                this.$alert({
                                    title: this.$t("3434"), // 학습을 중단한 강의입니다.
                                    content: this.$t("3435"), // 환불 요청 또는 신청 취소하여 학습이 중단된 강의는 더 이상 학습하실 수 없습니다.
                                    accept: this.$t("3436"), // 확인
                                })
                                .then(() => {})
                                .catch(() => {});
                            } else {
                                this.$router.push({
                                    name: "LessonView",
                                    params: {
                                        learnId: this.$route.params.learnId,
                                        lessonId: lesson.id,
                                        progressionId: lesson.progressionId,
                                    },
                                    query: this.$route.query,
                                });	
                            }
                        }).catch((err) => {
                        })
				
				} else {
                this.$router.push(`/learn-study/${learnId}/${lesson.id}/lessonContents/${lesson.progressionId}?status=`+status)
            }
        },
        setMaterialUi() {
            const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
                let button = new MDCRipple.attachTo(el)
                return button
            })
        },
    }
}
</script>